export default __webpack_public_path__ + "static/media/Newspaper-Mural.84002ee0.png";